import type { MarketingDocContent } from '../types';

/** Migrated from legacy visime.ch Impressum (company records; WP export unavailable). */
export const impressumDe: MarketingDocContent = {
  slug: 'impressum',
  title: 'Impressum',
  updated: '2026-03-22',
  description: 'Anbieterkennzeichnung und Kontakt der VisiMe Plattform.',
  sections: [
    {
      heading: 'Anbieter',
      paragraphs: [
        'VisiMe AG',
        'Schweiz',
        'E-Mail: support@visime.com',
      ],
    },
    {
      heading: 'Vertretungsberechtigte Person',
      paragraphs: ['Die vertretungsberechtigte Person ist auf Anfrage erreichbar unter support@visime.com.'],
    },
    {
      heading: 'Haftungsausschluss',
      paragraphs: [
        'Die Inhalte dieser Website werden mit grösster Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.',
        'Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.',
      ],
    },
    {
      heading: 'Urheberrecht',
      paragraphs: [
        'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem schweizerischen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung ausserhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.',
      ],
    },
  ],
};
